import type React from "react";

import { ChipDownContainer, EllipsisDropdownItem } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";
import { abbrNumberVisitsFilter } from "app/filters/ngFilters";
import type { ISourceItem } from "app/pages/website-analysis/social-overview/social-total-visits/socialTotalVisits";

export const SocialSourcesFilter: React.FC<{
    selectedSource: string;
    sources: Array<ISourceItem>;
    onChange: (source) => void;
}> = ({ selectedSource, sources = [], onChange }) => {
    const getSources = () =>
        sources.map((source, index: number) => (
            <EllipsisDropdownItem
                key={index}
                // @ts-expect-error Type number is not assignable to type string
                id={index}
                infoText={abbrNumberVisitsFilter()(source?.Count || 0)}
                disabled={source?.Count == 0}
            >
                {source.Name}
            </EllipsisDropdownItem>
        ));

    return (
        <ChipDownContainer
            width={200}
            tooltipDisabled={true}
            hasSearch={true}
            selectedIds={selectedSource ? { [selectedSource]: true } : undefined}
            selectedText={selectedSource}
            buttonText={i18nFilter()("forms.social.sources.all")}
            searchPlaceHolder=""
            onClick={onChange}
            onCloseItem={() => onChange(null)}
            disabled={!sources || sources.length === 0}
            noResultsMessage={i18nFilter()("dropdown.no.results")}
        >
            {getSources()}
        </ChipDownContainer>
    );
};
